// Shared framer-motion variants for a consistent premium feel.

export const easeOutExpo = [0.16, 1, 0.3, 1];
export const easeOutStrong = [0.19, 1, 0.22, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: easeOutExpo },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 1.1, ease: easeOutExpo },
  },
};

export const stagger = (delay = 0.08, initial = 0.05) => ({
  hidden: {},
  visible: {
    transition: {
      staggerChildren: delay,
      delayChildren: initial,
    },
  },
});

// Word / line reveal (masked)
export const revealLine = {
  hidden: { y: "110%" },
  visible: {
    y: "0%",
    transition: { duration: 1.1, ease: easeOutExpo },
  },
};

export const revealChar = {
  hidden: { y: "115%", opacity: 0 },
  visible: {
    y: "0%",
    opacity: 1,
    transition: { duration: 0.9, ease: easeOutExpo },
  },
};

export const viewportOnce = { once: true, amount: 0.25 };
